export const ACCOUNT_TYPES_RESET_STATE = 'ACCOUNT_TYPES_RESET_STATE';
export const ACCOUNT_TYPES_CURRENT_ITEM = 'ACCOUNT_TYPES_CURRENT_ITEM';

export const ACCOUNT_TYPES_REQUEST_LOADING = 'ACCOUNT_TYPES_REQUEST_LOADING';
export const ACCOUNT_TYPES_REQUEST_SUCCESS = 'ACCOUNT_TYPES_REQUEST_SUCCESS';
export const ACCOUNT_TYPES_REQUEST_FAILED = 'ACCOUNT_TYPES_REQUEST_FAILED';

export const ACCOUNT_TYPES_CURRENT_ACTION = 'ACCOUNT_TYPES_CURRENT_ACTION';
export const ACCOUNT_TYPES_RESET_ACTION = 'ACCOUNT_TYPES_RESET_ACTION';